export const SEVERITY_ERROR = 'error'
export const SEVERITY_WARNING = 'warning'
export const SEVERITY_SUCCESS = 'success'
export const SEVERITY_INFO = 'info'
export const REMOVE_TOAST = 'TOASTER_REMOVE_TOAST'
export const REMOVE_TOASTS = 'TOASTER_REMOVE_TOASTS'



// WEBPACK FOOTER //
// ./src/features/Toaster/data/constants.js